function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (t, n) {
  "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = n() : "function" === typeof define && define.amd ? define([], n) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-plain-pagination"] = n() : t["vue-plain-pagination"] = n();
})("undefined" !== typeof self ? self : this, function () {
  return function (t) {
    var n = {};

    function e(i) {
      if (n[i]) return n[i].exports;
      var a = n[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(a.exports, a, a.exports, e), a.l = !0, a.exports;
    }

    return e.m = t, e.c = n, e.d = function (t, n, i) {
      e.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: i
      });
    }, e.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, e.t = function (t, n) {
      if (1 & n && (t = e(t)), 8 & n) return t;
      if (4 & n && "object" === _typeof(t) && t && t.__esModule) return t;
      var i = Object.create(null);
      if (e.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t) for (var a in t) {
        e.d(i, a, function (n) {
          return t[n];
        }.bind(null, a));
      }
      return i;
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, e.p = "", e(e.s = "fb15");
  }({
    "0d58": function d58(t, n, e) {
      var i = e("ce10"),
          a = e("e11e");

      t.exports = Object.keys || function (t) {
        return i(t, a);
      };
    },
    "11e9": function e9(t, n, e) {
      var i = e("52a7"),
          a = e("4630"),
          r = e("6821"),
          o = e("6a99"),
          s = e("69a8"),
          u = e("c69a"),
          c = Object.getOwnPropertyDescriptor;
      n.f = e("9e1e") ? c : function (t, n) {
        if (t = r(t), n = o(n, !0), u) try {
          return c(t, n);
        } catch (e) {}
        if (s(t, n)) return a(!i.f.call(t, n), t[n]);
      };
    },
    1495: function _(t, n, e) {
      var i = e("86cc"),
          a = e("cb7c"),
          r = e("0d58");
      t.exports = e("9e1e") ? Object.defineProperties : function (t, n) {
        a(t);
        var e,
            o = r(n),
            s = o.length,
            u = 0;

        while (s > u) {
          i.f(t, e = o[u++], n[e]);
        }

        return t;
      };
    },
    "230e": function e(t, n, _e) {
      var i = _e("d3f4"),
          a = _e("7726").document,
          r = i(a) && i(a.createElement);

      t.exports = function (t) {
        return r ? a.createElement(t) : {};
      };
    },
    "2aba": function aba(t, n, e) {
      var i = e("7726"),
          a = e("32e9"),
          r = e("69a8"),
          o = e("ca5a")("src"),
          s = "toString",
          u = Function[s],
          c = ("" + u).split(s);
      e("8378").inspectSource = function (t) {
        return u.call(t);
      }, (t.exports = function (t, n, e, s) {
        var u = "function" == typeof e;
        u && (r(e, "name") || a(e, "name", n)), t[n] !== e && (u && (r(e, o) || a(e, o, t[n] ? "" + t[n] : c.join(String(n)))), t === i ? t[n] = e : s ? t[n] ? t[n] = e : a(t, n, e) : (delete t[n], a(t, n, e)));
      })(Function.prototype, s, function () {
        return "function" == typeof this && this[o] || u.call(this);
      });
    },
    "2aeb": function aeb(t, n, e) {
      var i = e("cb7c"),
          a = e("1495"),
          r = e("e11e"),
          o = e("613b")("IE_PROTO"),
          s = function s() {},
          u = "prototype",
          _c = function c() {
        var t,
            n = e("230e")("iframe"),
            i = r.length,
            a = "<",
            o = ">";
        n.style.display = "none", e("fab2").appendChild(n), n.src = "javascript:", t = n.contentWindow.document, t.open(), t.write(a + "script" + o + "document.F=Object" + a + "/script" + o), t.close(), _c = t.F;

        while (i--) {
          delete _c[u][r[i]];
        }

        return _c();
      };

      t.exports = Object.create || function (t, n) {
        var e;
        return null !== t ? (s[u] = i(t), e = new s(), s[u] = null, e[o] = t) : e = _c(), void 0 === n ? e : a(e, n);
      };
    },
    "2d00": function d00(t, n) {
      t.exports = !1;
    },
    "2d95": function d95(t, n) {
      var e = {}.toString;

      t.exports = function (t) {
        return e.call(t).slice(8, -1);
      };
    },
    "32e9": function e9(t, n, e) {
      var i = e("86cc"),
          a = e("4630");
      t.exports = e("9e1e") ? function (t, n, e) {
        return i.f(t, n, a(1, e));
      } : function (t, n, e) {
        return t[n] = e, t;
      };
    },
    4588: function _(t, n) {
      var e = Math.ceil,
          i = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? i : e)(t);
      };
    },
    4630: function _(t, n) {
      t.exports = function (t, n) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: n
        };
      };
    },
    "52a7": function a7(t, n) {
      n.f = {}.propertyIsEnumerable;
    },
    5537: function _(t, n, e) {
      var i = e("8378"),
          a = e("7726"),
          r = "__core-js_shared__",
          o = a[r] || (a[r] = {});
      (t.exports = function (t, n) {
        return o[t] || (o[t] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: i.version,
        mode: e("2d00") ? "pure" : "global",
        copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
      });
    },
    "5ca1": function ca1(t, n, e) {
      var i = e("7726"),
          a = e("8378"),
          r = e("32e9"),
          o = e("2aba"),
          s = e("9b43"),
          u = "prototype",
          c = function c(t, n, e) {
        var l,
            f,
            p,
            g,
            b = t & c.F,
            v = t & c.G,
            d = t & c.S,
            h = t & c.P,
            y = t & c.B,
            _ = v ? i : d ? i[n] || (i[n] = {}) : (i[n] || {})[u],
            m = v ? a : a[n] || (a[n] = {}),
            C = m[u] || (m[u] = {});

        for (l in v && (e = n), e) {
          f = !b && _ && void 0 !== _[l], p = (f ? _ : e)[l], g = y && f ? s(p, i) : h && "function" == typeof p ? s(Function.call, p) : p, _ && o(_, l, p, t & c.U), m[l] != p && r(m, l, g), h && C[l] != p && (C[l] = p);
        }
      };

      i.core = a, c.F = 1, c.G = 2, c.S = 4, c.P = 8, c.B = 16, c.W = 32, c.U = 64, c.R = 128, t.exports = c;
    },
    "5dbc": function dbc(t, n, e) {
      var i = e("d3f4"),
          a = e("8b97").set;

      t.exports = function (t, n, e) {
        var r,
            o = n.constructor;
        return o !== e && "function" == typeof o && (r = o.prototype) !== e.prototype && i(r) && a && a(t, r), t;
      };
    },
    "613b": function b(t, n, e) {
      var i = e("5537")("keys"),
          a = e("ca5a");

      t.exports = function (t) {
        return i[t] || (i[t] = a(t));
      };
    },
    "626a": function a(t, n, e) {
      var i = e("2d95");
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == i(t) ? t.split("") : Object(t);
      };
    },
    6821: function _(t, n, e) {
      var i = e("626a"),
          a = e("be13");

      t.exports = function (t) {
        return i(a(t));
      };
    },
    "69a8": function a8(t, n) {
      var e = {}.hasOwnProperty;

      t.exports = function (t, n) {
        return e.call(t, n);
      };
    },
    "6a99": function a99(t, n, e) {
      var i = e("d3f4");

      t.exports = function (t, n) {
        if (!i(t)) return t;
        var e, a;
        if (n && "function" == typeof (e = t.toString) && !i(a = e.call(t))) return a;
        if ("function" == typeof (e = t.valueOf) && !i(a = e.call(t))) return a;
        if (!n && "function" == typeof (e = t.toString) && !i(a = e.call(t))) return a;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    7726: function _(t, n) {
      var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = e);
    },
    "77f1": function f1(t, n, e) {
      var i = e("4588"),
          a = Math.max,
          r = Math.min;

      t.exports = function (t, n) {
        return t = i(t), t < 0 ? a(t + n, 0) : r(t, n);
      };
    },
    "79e5": function e5(t, n) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (n) {
          return !0;
        }
      };
    },
    8378: function _(t, n) {
      var e = t.exports = {
        version: "2.5.7"
      };
      "number" == typeof __e && (__e = e);
    },
    "86cc": function cc(t, n, e) {
      var i = e("cb7c"),
          a = e("c69a"),
          r = e("6a99"),
          o = Object.defineProperty;
      n.f = e("9e1e") ? Object.defineProperty : function (t, n, e) {
        if (i(t), n = r(n, !0), i(e), a) try {
          return o(t, n, e);
        } catch (s) {}
        if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
        return "value" in e && (t[n] = e.value), t;
      };
    },
    "8b97": function b97(t, n, e) {
      var i = e("d3f4"),
          a = e("cb7c"),
          r = function r(t, n) {
        if (a(t), !i(n) && null !== n) throw TypeError(n + ": can't set as prototype!");
      };

      t.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, n, i) {
          try {
            i = e("9b43")(Function.call, e("11e9").f(Object.prototype, "__proto__").set, 2), i(t, []), n = !(t instanceof Array);
          } catch (a) {
            n = !0;
          }

          return function (t, e) {
            return r(t, e), n ? t.__proto__ = e : i(t, e), t;
          };
        }({}, !1) : void 0),
        check: r
      };
    },
    9093: function _(t, n, e) {
      var i = e("ce10"),
          a = e("e11e").concat("length", "prototype");

      n.f = Object.getOwnPropertyNames || function (t) {
        return i(t, a);
      };
    },
    "9b43": function b43(t, n, e) {
      var i = e("d8e8");

      t.exports = function (t, n, e) {
        if (i(t), void 0 === n) return t;

        switch (e) {
          case 1:
            return function (e) {
              return t.call(n, e);
            };

          case 2:
            return function (e, i) {
              return t.call(n, e, i);
            };

          case 3:
            return function (e, i, a) {
              return t.call(n, e, i, a);
            };
        }

        return function () {
          return t.apply(n, arguments);
        };
      };
    },
    "9def": function def(t, n, e) {
      var i = e("4588"),
          a = Math.min;

      t.exports = function (t) {
        return t > 0 ? a(i(t), 9007199254740991) : 0;
      };
    },
    "9e1e": function e1e(t, n, e) {
      t.exports = !e("79e5")(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    },
    aa77: function aa77(t, n, e) {
      var i = e("5ca1"),
          a = e("be13"),
          r = e("79e5"),
          o = e("fdef"),
          s = "[" + o + "]",
          u = "​",
          c = RegExp("^" + s + s + "*"),
          l = RegExp(s + s + "*$"),
          f = function f(t, n, e) {
        var a = {},
            s = r(function () {
          return !!o[t]() || u[t]() != u;
        }),
            c = a[t] = s ? n(p) : o[t];
        e && (a[e] = c), i(i.P + i.F * s, "String", a);
      },
          p = f.trim = function (t, n) {
        return t = String(a(t)), 1 & n && (t = t.replace(c, "")), 2 & n && (t = t.replace(l, "")), t;
      };

      t.exports = f;
    },
    be13: function be13(t, n) {
      t.exports = function (t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    },
    c366: function c366(t, n, e) {
      var i = e("6821"),
          a = e("9def"),
          r = e("77f1");

      t.exports = function (t) {
        return function (n, e, o) {
          var s,
              u = i(n),
              c = a(u.length),
              l = r(o, c);

          if (t && e != e) {
            while (c > l) {
              if (s = u[l++], s != s) return !0;
            }
          } else for (; c > l; l++) {
            if ((t || l in u) && u[l] === e) return t || l || 0;
          }

          return !t && -1;
        };
      };
    },
    c5f6: function c5f6(t, n, e) {
      "use strict";

      var i = e("7726"),
          a = e("69a8"),
          r = e("2d95"),
          o = e("5dbc"),
          s = e("6a99"),
          u = e("79e5"),
          c = e("9093").f,
          l = e("11e9").f,
          f = e("86cc").f,
          p = e("aa77").trim,
          g = "Number",
          _b = i[g],
          v = _b,
          d = _b.prototype,
          h = r(e("2aeb")(d)) == g,
          y = ("trim" in String.prototype),
          _ = function _(t) {
        var n = s(t, !1);

        if ("string" == typeof n && n.length > 2) {
          n = y ? n.trim() : p(n, 3);
          var e,
              i,
              a,
              r = n.charCodeAt(0);

          if (43 === r || 45 === r) {
            if (e = n.charCodeAt(2), 88 === e || 120 === e) return NaN;
          } else if (48 === r) {
            switch (n.charCodeAt(1)) {
              case 66:
              case 98:
                i = 2, a = 49;
                break;

              case 79:
              case 111:
                i = 8, a = 55;
                break;

              default:
                return +n;
            }

            for (var o, u = n.slice(2), c = 0, l = u.length; c < l; c++) {
              if (o = u.charCodeAt(c), o < 48 || o > a) return NaN;
            }

            return parseInt(u, i);
          }
        }

        return +n;
      };

      if (!_b(" 0o1") || !_b("0b1") || _b("+0x1")) {
        _b = function b(t) {
          var n = arguments.length < 1 ? 0 : t,
              e = this;
          return e instanceof _b && (h ? u(function () {
            d.valueOf.call(e);
          }) : r(e) != g) ? o(new v(_(n)), e, _b) : _(n);
        };

        for (var m, C = e("9e1e") ? c(v) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), x = 0; C.length > x; x++) {
          a(v, m = C[x]) && !a(_b, m) && f(_b, m, l(v, m));
        }

        _b.prototype = d, d.constructor = _b, e("2aba")(i, g, _b);
      }
    },
    c69a: function c69a(t, n, e) {
      t.exports = !e("9e1e") && !e("79e5")(function () {
        return 7 != Object.defineProperty(e("230e")("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    },
    ca5a: function ca5a(t, n) {
      var e = 0,
          i = Math.random();

      t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + i).toString(36));
      };
    },
    cb7c: function cb7c(t, n, e) {
      var i = e("d3f4");

      t.exports = function (t) {
        if (!i(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    },
    ce10: function ce10(t, n, e) {
      var i = e("69a8"),
          a = e("6821"),
          r = e("c366")(!1),
          o = e("613b")("IE_PROTO");

      t.exports = function (t, n) {
        var e,
            s = a(t),
            u = 0,
            c = [];

        for (e in s) {
          e != o && i(s, e) && c.push(e);
        }

        while (n.length > u) {
          i(s, e = n[u++]) && (~r(c, e) || c.push(e));
        }

        return c;
      };
    },
    d3f4: function d3f4(t, n) {
      t.exports = function (t) {
        return "object" === _typeof(t) ? null !== t : "function" === typeof t;
      };
    },
    d8e8: function d8e8(t, n) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    },
    e11e: function e11e(t, n) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    },
    fab2: function fab2(t, n, e) {
      var i = e("7726").document;
      t.exports = i && i.documentElement;
    },
    fb15: function fb15(t, n, e) {
      "use strict";

      var i;
      (e.r(n), "undefined" !== typeof window) && (i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^\/]+\.js(\?.*)?$/)) && (e.p = i[1]);

      var a = function a() {
        var t = this,
            n = t.$createElement,
            e = t._self._c || n;
        return e("ul", {
          class: t.paginationClasses.ul
        }, [t.paginationLabels.first ? e("li", {
          class: t.paginationClasses.li + " " + (t.hasFirst ? t.paginationClasses.liDisable : "")
        }, [e("button", {
          class: t.paginationClasses.button + " " + (t.hasFirst ? t.paginationClasses.buttonDisable : ""),
          attrs: {
            disabled: t.hasFirst
          },
          domProps: {
            innerHTML: t._s(t.paginationLabels.first)
          },
          on: {
            click: t.first
          }
        })]) : t._e(), t.paginationLabels.prev ? e("li", {
          class: t.paginationClasses.li + " " + (t.hasFirst ? t.paginationClasses.liDisable : "")
        }, [e("button", {
          class: t.paginationClasses.button + " " + (t.hasFirst ? t.paginationClasses.buttonDisable : ""),
          attrs: {
            disabled: t.hasFirst
          },
          domProps: {
            innerHTML: t._s(t.paginationLabels.prev)
          },
          on: {
            click: t.prev
          }
        })]) : t._e(), e("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: 1 !== t.rangeFirstPage,
            expression: "rangeFirstPage !== 1"
          }],
          class: t.paginationClasses.li
        }, [e("button", {
          class: t.paginationClasses.button,
          on: {
            click: function click(n) {
              t.goto(1);
            }
          }
        }, [t._v("1")])]), e("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: 3 === t.rangeFirstPage,
            expression: "rangeFirstPage === 3"
          }],
          class: t.paginationClasses.li
        }, [e("button", {
          class: t.paginationClasses.button,
          on: {
            click: function click(n) {
              t.goto(2);
            }
          }
        }, [t._v("2")])]), e("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: 1 !== t.rangeFirstPage && 2 !== t.rangeFirstPage && 3 !== t.rangeFirstPage,
            expression: "rangeFirstPage !== 1 && rangeFirstPage !== 2 && rangeFirstPage !== 3"
          }],
          class: t.paginationClasses.li + " " + t.paginationClasses.liDisable
        }, [e("span", {
          class: t.paginationClasses.button + " " + t.paginationClasses.buttonDisable
        }, [t._v("...")])]), t._l(t.range, function (n) {
          return e("li", {
            key: n,
            class: t.paginationClasses.li + " " + (t.hasActive(n) ? t.paginationClasses.liActive : "")
          }, [e("button", {
            class: t.paginationClasses.button + " " + (t.hasActive(n) ? t.paginationClasses.buttonActive : ""),
            on: {
              click: function click(e) {
                t.goto(n);
              }
            }
          }, [t._v(t._s(n))])]);
        }), e("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.rangeLastPage !== t.pageCount && t.rangeLastPage !== t.pageCount - 1 && t.rangeLastPage !== t.pageCount - 2,
            expression: "rangeLastPage !== pageCount && rangeLastPage !== (pageCount - 1) && rangeLastPage !== (pageCount - 2)"
          }],
          class: t.paginationClasses.li + " " + t.paginationClasses.liDisable
        }, [e("span", {
          class: t.paginationClasses.button + " " + t.paginationClasses.buttonDisable
        }, [t._v("...")])]), e("li", {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: t.rangeLastPage === t.pageCount - 2,
            expression: "rangeLastPage === (pageCount - 2)"
          }],
          class: t.paginationClasses.li
        }, [e("button", {
          class: t.paginationClasses.button,
          on: {
            click: function click(n) {
              t.goto(t.pageCount - 1);
            }
          }
        }, [t._v(t._s(t.pageCount - 1))])]), t.rangeLastPage !== t.pageCount ? e("li", {
          class: t.paginationClasses.li
        }, [e("button", {
          class: t.paginationClasses.button,
          on: {
            click: function click(n) {
              t.goto(t.pageCount);
            }
          }
        }, [t._v(t._s(t.pageCount))])]) : t._e(), t.paginationLabels.next ? e("li", {
          class: t.paginationClasses.li + " " + (t.hasLast ? t.paginationClasses.liDisable : "")
        }, [e("button", {
          class: t.paginationClasses.button + " " + (t.hasLast ? t.paginationClasses.buttonDisable : ""),
          attrs: {
            disabled: t.hasLast
          },
          domProps: {
            innerHTML: t._s(t.paginationLabels.next)
          },
          on: {
            click: t.next
          }
        })]) : t._e(), t.paginationLabels.last ? e("li", {
          class: t.paginationClasses.li + " " + (t.hasLast ? t.paginationClasses.liDisable : "")
        }, [e("button", {
          class: t.paginationClasses.button + " " + (t.hasLast ? t.paginationClasses.buttonDisable : ""),
          attrs: {
            disabled: t.hasLast
          },
          domProps: {
            innerHTML: t._s(t.paginationLabels.last)
          },
          on: {
            click: t.last
          }
        })]) : t._e()], 2);
      },
          r = [];

      function o(t, n, e) {
        return n in t ? Object.defineProperty(t, n, {
          value: e,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[n] = e, t;
      }

      function s(t) {
        for (var n = 1; n < arguments.length; n++) {
          var e = null != arguments[n] ? arguments[n] : {},
              i = Object.keys(e);
          "function" === typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(e).filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          }))), i.forEach(function (n) {
            o(t, n, e[n]);
          });
        }

        return t;
      }

      e("c5f6");
      var u = 3,
          c = {
        ul: "pagination",
        li: "pagination-item",
        liActive: "pagination-item--active",
        liDisable: "pagination-item--disable",
        button: "pagination-link",
        buttonActive: "pagination-link--active",
        buttonDisable: "pagination-link--disable"
      },
          l = {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      },
          f = {
        props: {
          value: {
            type: Number,
            required: !0
          },
          pageCount: {
            type: Number,
            required: !0
          },
          classes: {
            type: Object,
            required: !1,
            default: function _default() {
              return {};
            }
          },
          labels: {
            type: Object,
            required: !1,
            default: function _default() {
              return {};
            }
          }
        },
        data: function data() {
          return {
            paginationClasses: s({}, c, this.classes),
            paginationLabels: s({}, l, this.labels)
          };
        },
        mounted: function mounted() {
          this.value > this.pageCount && this.$emit("input", this.pageCount);
        },
        computed: {
          rangeFirstPage: function rangeFirstPage() {
            return 1 === this.value ? 1 : this.value === this.pageCount ? this.pageCount - u < 0 ? 1 : this.pageCount - u + 1 : this.value - 1;
          },
          rangeLastPage: function rangeLastPage() {
            return Math.min(this.rangeFirstPage + u - 1, this.pageCount);
          },
          range: function range() {
            for (var t = [], n = this.rangeFirstPage; n <= this.rangeLastPage; n += 1) {
              t.push(n);
            }

            return t;
          },
          hasFirst: function hasFirst() {
            return 1 === this.value;
          },
          hasLast: function hasLast() {
            return this.value === this.pageCount;
          }
        },
        watch: {
          value: function value() {
            this.$emit("change");
          }
        },
        methods: {
          first: function first() {
            this.hasFirst || this.$emit("input", 1);
          },
          prev: function prev() {
            this.hasFirst || this.$emit("input", this.value - 1);
          },
          goto: function goto(t) {
            this.$emit("input", t);
          },
          next: function next() {
            this.hasLast || this.$emit("input", this.value + 1);
          },
          last: function last() {
            this.hasLast || this.$emit("input", this.pageCount);
          },
          hasActive: function hasActive(t) {
            return t === this.value;
          }
        }
      },
          p = f;

      function g(t, n, e, i, a, r, o, s) {
        var u,
            c = "function" === typeof t ? t.options : t;
        if (n && (c.render = n, c.staticRenderFns = e, c._compiled = !0), i && (c.functional = !0), r && (c._scopeId = "data-v-" + r), o ? (u = function u(t) {
          t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" === typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), a && a.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
        }, c._ssrRegister = u) : a && (u = s ? function () {
          a.call(this, this.$root.$options.shadowRoot);
        } : a), u) if (c.functional) {
          c._injectStyles = u;
          var l = c.render;

          c.render = function (t, n) {
            return u.call(n), l(t, n);
          };
        } else {
          var f = c.beforeCreate;
          c.beforeCreate = f ? [].concat(f, u) : [u];
        }
        return {
          exports: t,
          options: c
        };
      }

      var b = g(p, a, r, !1, null, null, null);
      b.options.__file = "vue-plain-pagination.vue";
      var v = b.exports;
      n["default"] = v;
    },
    fdef: function fdef(t, n) {
      t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    }
  })["default"];
});